import _loadjs from 'loadjs';

export const loadModule = ({ module, files = [], async = false, success, error }) => {
  const loadjs = window.loadjs || _loadjs;
  loadjs.isDefined(module)
    ? loadjs.ready(module, { success, error })
    : loadjs(files, module, { async, success, error });
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/util/loadjsUtil.js